import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Box, Container, Text } from "@chakra-ui/react";
import { Navbar } from "@/components/navbar";
import { Toaster } from "@/components/ui/toaster";
import { getAuthUser } from "@/lib/server-fns";
import type { AuthUser } from "@/lib/server-fns";
import { getVersionMetadata } from "@/routes/__root";
import { StandaloneError } from "@/components/error-page";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async () => {
    const user = await getAuthUser();
    if (!user) {
      throw redirect({ to: "/login" });
    }
    return { user };
  },
  loader: async () => {
    try {
      return await getVersionMetadata();
    } catch {
      return { id: "", tag: "dev" };
    }
  },
  component: AuthenticatedLayout,
  errorComponent: ({ error, reset }) => <StandaloneError error={error} reset={reset} />,
});

function AuthenticatedLayout() {
  const { user } = Route.useRouteContext() as { user: AuthUser };
  const { tag } = Route.useLoaderData();

  return (
    <Box display="flex" flexDirection="column" minH="100vh">
      <Navbar name={user.name} email={user.email} userId={user.userId} />
      <Container maxW="breakpoint-xl" px="4" py={{ base: "4", md: "6" }} flex="1">
        <Outlet />
      </Container>
      <Box as="footer" py="4" textAlign="center">
        <Text fontSize="2xs" color="fg.subtle" fontFamily="mono">
          {tag}
        </Text>
      </Box>
      <Toaster />
    </Box>
  );
}
